import React from "react";
import { Outlet } from "react-router-dom";
import { OrchestratorProvider } from "./contexts/OrchestratorContext";

const MultiPlayerLayout: React.FC = () => {
  return (
    <OrchestratorProvider>
      <Outlet />
    </OrchestratorProvider>
  );
};

export default MultiPlayerLayout;